import React, { useState } from 'react'
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setUspsMailToRecipientsCreditCardModal, setUspsMailToRecipientsModal } from '../ManageFederalFormsSlice'
import PaymentDrawer from '../../../../components/paymentdrawer/PaymentDrawer'
import { PLACE_OF_ORIGIN_FOR_PAYMENT, PRICING } from '../../../../components/paymentdrawer/constants'
import ManageFormsService from '../../../../../../services/ManageFormsService'
import { getFederalGridData } from '../ManageFederalFormsSaga'
import { componentKey as uspsMailComponentKey } from './USPSMailToRecipientSlice'
import useGarbageCollector from '../../../../../../libs/garbagecollector/garbageCollectorHooks'
import { getUSPSMailFee } from './USPSMailToRecipientSaga'
import { USPS_MAIL_TO_RECIPIENT_LOADING_STATES } from './constants'

const USPSMailToRecipients = ({ isOpen = false, onCancelCb = () => { }, payerDetails = {}, selectedForms = [], taxYear = {} }) => {

    useGarbageCollector(uspsMailComponentKey);
    const dispatch = useDispatch();
    const { USPSMailToRecipientFees, loadingStates } = useSelector(state => state[uspsMailComponentKey])
    const { uspsMailToRecipientsCreditCardModal, federalStates, paginationState } = useSelector(state => state[componentKey]);
    const [isAllSelected, setIsAllSelected] = useState(false);

    return (
        <>
        {
            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Do you want to request USPS mail for all recipients under the selected payer, or request USPS mail for only selected recipients?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={isOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setUspsMailToRecipientsModal(false))
                        const data = {
                            AllSelected: true,
                            payerId: payerDetails?.PayerDetailId,
                            taxYear: taxYear?.value,
                            payerName: payerDetails?.LastName,
                            data: selectedForms.map(selectedForm => ({
                                key: "true",
                                formTypeId: selectedForm.FormTypeId,
                                formId: selectedForm.FormId,
                                formName: selectedForm.FormName,
                                ForeignKey: (selectedForm?.ForeignAddress && selectedForm?.ForeignAddress === "1") ? true : false,
                                ReferenceNumber: selectedForm?.referenceNumber
                            }))
                        }
                        setIsAllSelected(true);
                        dispatch(getUSPSMailFee(data));
                    },
                    confirmationButtonText: "All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    cancelButtonText: "Only Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    onCancelCb: () => {
                        const data = {
                            AllSelected: false,
                            payerId: payerDetails?.PayerDetailId,
                            taxYear: taxYear?.value,
                            payerName: payerDetails?.LastName,
                            data: selectedForms.map(selectedForm => ({
                                key: "true",
                                formTypeId: selectedForm.FormTypeId,
                                formId: selectedForm.FormId,
                                formName: selectedForm.FormName,
                                ForeignKey: (selectedForm?.ForeignAddress && selectedForm?.ForeignAddress === "1") ? true : false,
                                ReferenceNumber: selectedForm?.referenceNumber
                            }))
                        }
                        setIsAllSelected(false)
                        dispatch(getUSPSMailFee(data));
                        onCancelCb();
                    },
                    onCloseCb: onCancelCb,
                }}
                isClose={false}
                loadingState={loadingStates?.state}
                loaderLoadingStates={[USPS_MAIL_TO_RECIPIENT_LOADING_STATES.USPS_MAIL_FEE_LOADING]}
            />
        }
        {
            uspsMailToRecipientsCreditCardModal &&
                <PaymentDrawer
                    isOpen={uspsMailToRecipientsCreditCardModal}
                    isUsps={true}
                    onCloseCb={() => dispatch(setUspsMailToRecipientsCreditCardModal(false))}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: USPSMailToRecipientFees,
                        FilingFee: "0",
                        USPSFee: USPSMailToRecipientFees,
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: selectedForms.length
                    }}
                    filingFeeLabel={`USPS Mail to recipient fees`}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={ManageFormsService.uspsMailtoRecipient}
                    onPaymentSuccessCb={() => {
                        if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0) {
                            dispatch(getFederalGridData({ payerId: federalStates.FederalPayer.value, taxYear: federalStates.FederalTaxYear.value, FilterText: paginationState.FilterText, PagFederalPayereNumber: paginationState.PageNumber, PageSize: paginationState.PageSize, IsDesc: paginationState.IsDesc }))
                        }
                    }}
                    placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.USPS_PAYMENT}
                    paymentServiceFunctionExtraParams={{

                        data: selectedForms.map(row => {
                            const obj = {};

                            obj.formId = row?.FormId;
                            obj.formTypeId = row?.FormTypeId;
                            obj.formName = row?.FormName;
                            obj.ForeignKey = row?.ForeignAddress === "0" ? false : true; // If US pass true or false
                            obj.ReferenceNumber = row?.ReferenceNumber

                            return obj;
                        }),

                        AllSelected: isAllSelected,
                        taxYear: taxYear?.value,
                        totalAmount: `${PRICING.USPS_MAIL_TO_RECIPIENT}`,
                        payerId: payerDetails?.value,
                        payername: payerDetails?.LastName,
                    }}
                />
        }

        </>
    )
}

export default USPSMailToRecipients
